// const { default: axios } = require("axios");

// the account settings Alpine object
window.appAccount = (username) => {
    return {
        username: {
            orginalValue: username,
            value: username,
            label: '',
            editing: false
        },
        password: {
            orginalValue: getLang('password'),
            value: getLang('password'),
            label: '',
            editing: false
        },
        init: function() {
            this.username.label = getLang('edit');
            this.password.label = getLang('edit');

            this.$store.lang = config.lang;
            Spruce.watch('lang', () => this.setLanguage());
        },
        editUsername: async function() {
            // if not already editing
            if( ! this.username.editing ) {
                this.username.editing = true;
                this.username.label = getLang('save');
                this.$refs.username.select();

            // if already editing
            } else {
                const msg = getLang('save_username', {'%USERNAME%': this.username.value});
                const doEdit = await modalConfirm(msg, getLang('save'));
                this.username.editing = false;
                this.username.label = getLang('edit');
                if( doEdit ) {
                    axios.post('/api/save-username', {
                        'username': this.username.value,
                    })
                        .then( () => {
                            this.username.orginalValue = this.username.value;
                        });
                } else {
                    this.username.value = this.username.orginalValue;
                }
            }
        },
        editPassword: async function() {
            // if not already editing
            if( ! this.password.editing ) {
                this.password.editing = true;
                this.password.label = getLang('save');
                this.password.value = '';
                this.$refs.password.select();

            // if already editing
            } else {

                const msg = getLang('save_password');
                const doEdit = await modalConfirm(msg, getLang('save'));
                this.password.editing = false;
                this.password.label = getLang('edit');
                if( doEdit ) {
                    //check password is at least 8 cahracters long and contains a non alphanumeric character
                    if( this.password.value.length < 8 || this.password.value.match(/^[a-z0-9]+$/i)) {
                        modal(getLang('invalid_password'));
                        this.password.value = this.password.orginalValue;
                        return;
                    }
                    axios.post('/api/save-password', {
                        'password': this.password.value,
                    })
                        .then( () => {
                            this.password.orginalValue = this.password.value;
                        });
                } else {
                    this.password.value = this.password.orginalValue;
                }
            }
        },
        setLanguage: function() {
            if( this.$store.language === config.lang) {
                return;
            }
            axios.get('/set-language/' + this.$store.lang)
                .then( () => location.reload() )
                .catch(ajaxFail)
        }
    }
};
